var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-slide-group',[_c('v-row',{attrs:{"justify":"space-around"}},_vm._l((_vm.categories),function(category,i){return _c('v-slide-item',{key:i},[_c('v-col',{attrs:{"cols":"auto"}},[_c('v-card',{attrs:{"ripple":false,"flat":"","tile":"","color":"transparent","max-width":"80","to":{
            name: 'categoryTemplate',
            params: {
              category_id: category.id,
              category_name: _vm.slugify(category.category_name)
            }
          }}},[_c('v-img',{attrs:{"width":"80","height":"80","src":category.image}}),_c('v-card-actions',{staticClass:"text-center text-caption text--secondary"},[_vm._v(" "+_vm._s(category.category_name)+" ")])],1)],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }